// lightbox ( https://www.lightgalleryjs.com/ )
jQuery(document).ready(function ($) {
  $('.js-gallery').each(function () {
    lightGallery(this, {
      plugins: [lgThumbnail],
      licenseKey: 'D61982B3-B024-4CDA-88EB-1BBD713DB49A',
      thumbnail: false,
      exThumbImage: 'data-thumb',
      download: false,
      selector: 'a',
      subHtmlSelectorRelative: true,
      mobileSettings: {
        showCloseIcon: true,
      },
    });

    // název a odkaz na bazén
    $(this).on('lgAfterOpen', function () {
      if ($(this).parent().data('pool')) {
        var poolName = $(this).parent().data('pool');
        var poolUrl = $(this).parent().data('poolurl');

        $('.lightbox__title, .lightbox__link').remove();
        $('.lg-counter').before('<div class="lightbox__title">' + poolName + '</div>');
        $('.lg-close').after('<div class="lightbox__link"><a class="btn" href="' + poolUrl + '">Detail bazénu</a></div>');
      }
    });
  });

  $('a.js-gallery').each(function () {
    lightGallery(this, {
      plugins: [lgThumbnail],
      licenseKey: 'D61982B3-B024-4CDA-88EB-1BBD713DB49A',
      download: false,
      thumbnail: false,
      mobileSettings: {
        showCloseIcon: true,
      },
    });
  });
});

jQuery(document).ready(function ($) {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // události při scroolování
  $(window).on('scroll', function () {
    // aktivní kotvy
    anchorsMenu();
    // rolovací menu
    rollMenu();
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav__switcher').hasClass('is-open')) {
      $('.nav, .nav__switcher, .header').removeClass('is-open').attr('aria-expanded', 'false');
      $('.nav__switcher').text('Menu');
    } else {
      $('.nav, .nav__switcher, .header').addClass('is-open').attr('aria-expanded', 'true');
      $('.nav__switcher').text('Zavřít');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav, .nav__switcher, .header').removeClass('is-open').attr('aria-expanded', 'false');
    $('.nav__switcher').text('Menu');
  }
  // spouštěč
  $('.nav__switcher').on('click', function () {
    switchMenu();
  });
  // aria atributy k menu
  if (window.innerWidth < 992) {
    $('.nav, .nav__switcher').attr('aria-expanded', 'false');
  }

  // rolovací menu
  function rollMenu() {
    if ($(this).scrollTop() > 200) {
      $('.header--secondary').addClass('is-active');
    } else {
      $('.header--secondary').removeClass('is-active');
    }
  }
  rollMenu();

  // cookies - nastavení
  function setCookieHours(name, value, hours) {
    var expires = '';

    if (hours) {
      var date = new Date();
      date.setTime(date.getTime() + hours * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }

    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  }

  // cookies - vytažení
  function getCookie(name) {
    var match = document.cookie.match(RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? match[1] : null;
  }

  // upozornění
  if ($('.highlight').length) {
    // zobrazíme pokud nebude existovat cookie
    if (!getCookie('cookie_highlight')) {
      $('.highlight').addClass('is-open');
    }

    // zavření popup okna
    $('.highlight__close').on('click', function (event) {
      event.preventDefault();

      $(this).closest('.highlight').removeClass('is-open');

      setCookieHours('cookie_highlight', 'hide', 72);
    });
  }

  // FAQ - otevírání
  if ($('.faq').length) {
    $('.faq__question').on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('is-open');
    });
  }

  // poradna - zobrazení celého seznamu
  if ($('.js-advice-list').length) {
    $('.js-advice-list').on('click', function () {
      $(this).parent().prev('ul').removeClass('is-hidden');
      $(this).parent().hide();
    });
  }

  // formulář - ověření
  if ($('.form__assure').length) {
    $('.form__assure').val('37608d1c57Febb');
  }

  // formulář - referer
  if ($('#your-referer').length) {
    var referer = document.referrer;
    $('#your-referer').val(referer);
  }

  // video - doplnění src
  if ($('.video').length) {
    $('.video').on('click', function () {
      var videoSrc = $(this).find('iframe').data('src');
      $(this).addClass('is-active');
      $(this).find('iframe').attr('src', videoSrc);
    });
  }

  // formulář - ověření a validace
  if ($('#form-showroom').length) {
    $('#form-showroom').submit(function (event) {
      var dateValid = $('#your-date').val() !== '';
      var timeValid = $('#your-time').val() !== '';
      var emailValid = /^[a-zA-Z0-9._%+-]{2,}@[a-zA-Z0-9.-]{2,}\.[a-zA-Z]{2,}$/.test($('#your-email').val());

      if (!dateValid || !timeValid) {
        event.preventDefault();
        alert('Prosím vyberte datum a čas!');
      } else if (!emailValid) {
        event.preventDefault();
        alert('Prosím zadejte platný e-mail!');
      }
    });
  }

  // aktivní kotvy
  function anchorsMenu() {
    var scrollTop = $(document).scrollTop();
    var documentHeight = $(document).height();
    var windowHeight = $(window).height();
    var anchors = $('body').find('section');

    $('.content-nav ul li a').removeClass('is-active');

    for (var i = 0; i < anchors.length; i++) {
      if (scrollTop > $(anchors[i]).offset().top - 51 && scrollTop < $(anchors[i]).offset().top + $(anchors[i]).height() - 51) {
        $('.content-nav ul li a[href="#' + $(anchors[i]).attr('id') + '"]').addClass('is-active');
      }
    }
  }
  anchorsMenu();

  // odpočet času
  if ($('.countdown__timer').data('time')) {
    var countDownStart = $('.countdown__timer').data('time');
    var countDownDate = new Date(countDownStart).getTime();

    // update každou vteřinu
    var x = setInterval(function () {
      // aktuální datum a čas
      var now = new Date().getTime();

      // rozdíl + kalkulace času
      var distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // výpis
      $('.countdown__timer').html('<li><strong>' + days + '</strong> dny</li>' + '<li><strong>' + hours + '</strong> hodiny</li>' + '<li><strong>' + minutes + '</strong> minuty</li>' + '<li><strong>' + seconds + '</strong> vteřiny</li>');

      if (distance > 0) {
        $('.countdown').addClass('is-visible');
      } else {
        clearInterval(x);
      }
    }, 1000);
  }
});

//# sourceMappingURL=scripts.js.map
